import {Button, Grid, IconButton, InputAdornment, OutlinedInput, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import {clone, isAdministrator} from "../framework/utils";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";
import {DeleteForever, Visibility, VisibilityOff} from "@mui/icons-material";

export function AdminCompetencesPage(props) {

  const [competences, setCompetences] = useState([]);

  useEffect(() => {
    API.getAPI().get_competences().then((response)=> {
      console.log(response.data);
      setCompetences(response.data);
    });
  }, []);

  const findCompetenceIndex = (id) => {
    let idx = null;
    competences.forEach((competence, i) => {
      if (competence.id == id) {
        idx = i;
      }
    });

    return idx;
  };

  const handleChangeCompetence = (e, id) => {

    let newCompetences = clone(competences);

    const idx = findCompetenceIndex(id);
    if (idx !== null) {
      newCompetences[idx].competence = e.target.value;
      setCompetences(newCompetences);
    }
  };

  const removeCompetence = (id) => {

    let newCompetences = clone(competences);

    const idx = findCompetenceIndex(id);
    if (idx !== null) {
      newCompetences.splice(idx, 1);
      setCompetences(newCompetences);
    }
  };

  const handleSave = () => {
    API.getAPI().admin_set_competences(competences).then((response)=> {
      setCompetences(response.data);
    });
  };

  if (!isAdministrator()) {
    document.location.hash = "#/anslagstavlan";
    return;
  }

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Anslagstavlan [ADMIN]</div>
      <div className={"App-subTitle"}>Funktioner för administratörer.</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={3} sm={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={9} sm={9} className={"App-container-rightContent"}>
          <div className={"App-rightContent"}>
            <Grid container={true} spacing={1}>

              {/*** App Right content ***/}

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Administrera kompetenser</div>
              </Grid>
              {competences.map(competence => (
                <Grid item xs={12} sm={6} id={competence.id}>
                  <OutlinedInput
                    style={{ minWidth: '100%' }}
                    value={competence.competence}
                    onChange={(e)=> handleChangeCompetence(e, competence.id)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={()=>{ removeCompetence(competence.id) }}
                          edge="end"
                        >
                          <DeleteForever />
                        </IconButton>
                      </InputAdornment>
                    }
                  />

                </Grid>
              ))}
              <Grid item xs={12} sm={12}>

                <Button
                  className={"App-button-contained"}
                  variant={"contained"}
                  onClick={handleSave}
                >
                  Spara
                </Button>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
